import axios from 'axios';
import { API_BASE_URL } from '@/config';

export class ManagedAccountsApi {
  static getPaymentsManager = (id) =>
    axios.get(`${API_BASE_URL}/managed-accounts/${id}/payments-manager`, {
      skipToast: true,
    });

  static updatePaymentsManager = (id, data) =>
    axios.put(`${API_BASE_URL}/managed-accounts/${id}/payments-manager`, data, {
      skipToast: true,
    });

  static testPaymentsManagerConnection = (id) =>
    axios.post(
      `${API_BASE_URL}/managed-accounts/${id}/payments-manager/test-connection`,
      undefined,
      { skipToast: true },
    );
}
